var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard3Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-453 -2525)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.2,
    filter: "url(#filter0_f_13_7334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.5,
    cy: 27.5,
    rx: 374.5,
    ry: 395.5,
    transform: "rotate(90 481.5 27.5)",
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    filter: "url(#filter1_d_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -39.23,
    width: 547.19,
    height: 265.77,
    rx: 19,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "span.lqd-bg-layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -39.23,
    width: 547.19,
    height: 265.77,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip1_13_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4505 5.55735C20.1805 3.83637 18.4668 2.49267 16.4926 1.66973C14.5184 0.846802 12.3577 0.575547 10.2413 0.884935C8.18277 1.1776 6.23667 2.00376 4.59629 3.28135C2.95591 4.55893 1.67836 6.24348 0.890529 8.16765C0.102705 10.0918 -0.167965 12.1886 0.105407 14.2498C0.37878 16.3109 1.18668 18.2647 2.44885 19.917C2.98626 20.6576 3.26769 21.5533 3.25052 22.4682V23.5201C3.25052 24.3821 3.59293 25.2087 4.20242 25.8182C4.81192 26.4277 5.63857 26.7701 6.50052 26.7701H14.0839C14.9458 26.7701 15.7725 26.4277 16.382 25.8182C16.9915 25.2087 17.3339 24.3821 17.3339 23.5201H17.869C19.1818 23.5169 20.4491 23.0384 21.4363 22.1731C22.4235 21.3077 23.064 20.1141 23.2391 18.813L23.4764 17.0201H23.8339C24.1201 17.0262 24.4045 16.9743 24.6701 16.8675C24.9357 16.7608 25.177 16.6014 25.3794 16.399C25.5818 16.1966 25.7412 15.9553 25.8479 15.6897C25.9547 15.4241 26.0066 15.1396 26.0005 14.8535C26.0005 13.3151 22.8242 7.25385 21.4505 5.55735ZM22.5263 14.8535C22.2636 14.8536 22.0099 14.9491 21.8124 15.1223C21.615 15.2954 21.4871 15.5345 21.4527 15.7949L21.0909 18.5303C20.9856 19.3107 20.6013 20.0267 20.009 20.5457C19.4167 21.0647 18.6565 21.3516 17.869 21.3535H16.2505C15.9632 21.3535 15.6877 21.4676 15.4845 21.6708C15.2813 21.8739 15.1672 22.1495 15.1672 22.4368V23.5201C15.1672 23.8074 15.0531 24.083 14.8499 24.2862C14.6467 24.4893 14.3712 24.6035 14.0839 24.6035H6.50052C6.2132 24.6035 5.93765 24.4893 5.73449 24.2862C5.53132 24.083 5.41719 23.8074 5.41719 23.5201V22.4682C5.43356 21.0774 4.99578 19.7191 4.17027 18.5996C3.13879 17.2485 2.47848 15.6511 2.25487 13.966C2.03125 12.2808 2.25209 10.5665 2.89547 8.99309C3.53886 7.41966 4.58244 6.04179 5.92268 4.99614C7.26293 3.9505 8.85327 3.27343 10.5359 3.0321C10.9954 2.96832 11.4587 2.93647 11.9226 2.93677C13.4449 2.93472 14.9462 3.29148 16.3047 3.97811C17.6633 4.66475 18.841 5.66192 19.7421 6.88877C21.4531 9.35053 22.8291 12.0289 23.8339 14.8535H22.5263ZM17.5505 9.44869C17.4797 9.32521 17.3852 9.21692 17.2724 9.13C17.1597 9.04307 17.0309 8.97922 16.8935 8.9421C16.756 8.90497 16.6126 8.8953 16.4715 8.91363C16.3303 8.93196 16.1941 8.97794 16.0707 9.04894L15.0069 9.65994C14.4551 9.1007 13.7615 8.70223 13.0005 8.50727V7.2701C13.0005 6.98278 12.8864 6.70723 12.6832 6.50407C12.4801 6.30091 12.2045 6.18677 11.9172 6.18677C11.6299 6.18677 11.3543 6.30091 11.1512 6.50407C10.948 6.70723 10.8339 6.98278 10.8339 7.2701V8.50727C10.0717 8.70168 9.37691 9.10019 8.82427 9.65994L7.76044 9.04894C7.63709 8.9778 7.50095 8.93166 7.35977 8.91314C7.21859 8.89463 7.07515 8.9041 6.93764 8.94102C6.80012 8.97794 6.67122 9.04158 6.5583 9.12832C6.44538 9.21505 6.35065 9.32317 6.27952 9.44652C6.20839 9.56986 6.16225 9.70601 6.14373 9.84719C6.12521 9.98836 6.13469 10.1318 6.1716 10.2693C6.20852 10.4068 6.27217 10.5357 6.3589 10.6487C6.44563 10.7616 6.55376 10.8563 6.6771 10.9275L7.75285 11.546C7.64515 11.9169 7.5883 12.3006 7.58385 12.6868C7.58935 13.0731 7.6473 13.4568 7.7561 13.8275L6.68035 14.4461C6.43125 14.5898 6.24942 14.8265 6.17485 15.1042C6.10029 15.382 6.13911 15.6779 6.28277 15.927C6.42643 16.1761 6.66316 16.358 6.94089 16.4325C7.21861 16.5071 7.51458 16.4683 7.76369 16.3246L8.82752 15.7136C9.37926 16.2729 10.0728 16.6713 10.8339 16.8663V18.1035C10.8339 18.3908 10.948 18.6663 11.1512 18.8695C11.3543 19.0727 11.6299 19.1868 11.9172 19.1868C12.2045 19.1868 12.4801 19.0727 12.6832 18.8695C12.8864 18.6663 13.0005 18.3908 13.0005 18.1035V16.8663C13.7627 16.6719 14.4575 16.2734 15.0101 15.7136L16.0739 16.3246C16.1973 16.3958 16.3334 16.4419 16.4746 16.4604C16.6158 16.4789 16.7592 16.4695 16.8967 16.4325C17.0343 16.3956 17.1632 16.332 17.2761 16.2452C17.389 16.1585 17.4837 16.0504 17.5549 15.927C17.626 15.8037 17.6721 15.6675 17.6907 15.5264C17.7092 15.3852 17.6997 15.2418 17.6628 15.1042C17.6259 14.9667 17.5622 14.8378 17.4755 14.7249C17.3888 14.612 17.2806 14.5173 17.1573 14.4461L16.0815 13.8275C16.1892 13.4567 16.2461 13.0729 16.2505 12.6868C16.245 12.3005 16.1871 11.9167 16.0783 11.546L17.154 10.9275C17.4025 10.7838 17.5839 10.5474 17.6582 10.2701C17.7326 9.99284 17.6938 9.69741 17.5505 9.44869ZM11.9172 14.8535C11.4887 14.8535 11.0698 14.7264 10.7135 14.4883C10.3572 14.2502 10.0794 13.9118 9.91545 13.5159C9.75146 13.12 9.70855 12.6844 9.79215 12.2641C9.87575 11.8438 10.0821 11.4577 10.3851 11.1547C10.6881 10.8517 11.0742 10.6453 11.4945 10.5617C11.9148 10.4781 12.3504 10.521 12.7463 10.685C13.1423 10.849 13.4806 11.1267 13.7187 11.4831C13.9568 11.8394 14.0839 12.2583 14.0839 12.6868C14.0839 13.2614 13.8556 13.8125 13.4493 14.2189C13.0429 14.6252 12.4918 14.8535 11.9172 14.8535Z",
    fill: "url(#paint0_linear_13_7334)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_7334",
    x: -318.1,
    y: -751.1,
    width: 1599.2,
    height: 1557.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.05,
    result: "effect1_foregroundBlur_13_7334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_7334",
    x: -104,
    y: -79.23,
    width: 635.189,
    height: 353.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 0.00195304,
    y1: 0.760742,
    x2: 26.0113,
    y2: 26.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DAC5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-453 -2525)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.77002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3Img);
export default __webpack_public_path__ + "static/media/card3Img.b2f821b6aed0ca459fbb2f40af994e58.svg";
export { ForwardRef as ReactComponent };